// extracted by mini-css-extract-plugin
export default {"gradient-bg5":"ratingTrend-module__gradient-bg5__LU8EN","ratingTrend":"ratingTrend-module__ratingTrend__IyVqS"};